export const API_CONFIG = {
  ADMIN_API: import.meta.env.VITE_ADMIN_API_URL || 'http://localhost:8087/api/v1',
  TIMEOUT: 15000,
};

export const APP_NAME = import.meta.env.VITE_APP_NAME || 'CS E2';

export const PUBLIC_APP_URL = import.meta.env.VITE_PUBLIC_APP_URL || 'http://localhost:3000';
